import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AsyncComputed from 'vue-async-computed'
import axios from 'axios';

Vue.config.productionTip = false
Vue.use(AsyncComputed);

//I am checking if users are logged in globally in main.js, so for all my vues I can know if I am logged in or not
//v-if="user" will check in vues if the user is logged in
let main = async function () {
  let response = null;
  try {
    response = await axios.get('/api/users');
  }
  catch (ex) {
    // This just means they're not logged in, let it go on
  }

  const user = response !== null ? response.data.user : null; //the user's record is stored in a global data

  let data = { //keeps track of the currently logged in user
    user: user
  }

  new Vue({
    data,
    router,
    render: h => h(App)
  }).$mount('#app')
};

main();